import { Alert, Card, Tabs, Typography } from 'antd';
import DealerInvestmentsTab from '../components/dealer/DealerInvestmentsTab';
import DealerLedgerTab from '../components/dealer/DealerLedgerTab';
import DealerMyDashboard from '../components/dealer/DealerMyDashboard';
import DealerProfileTab from '../components/dealer/DealerProfileTab';
import DealerProfitTab from '../components/dealer/DealerProfitTab';
import DealerWithdrawalsTab from '../components/dealer/DealerWithdrawalsTab';
import { useAuth } from '../context/AuthContext';

/**
 * Read-only self-service view for dealer-role logins — the mirror of InvestorPortalPage. The write
 * buttons inside the shared tabs are hidden by each tab's own `hasRole('Admin')` check, and the API
 * rejects a dealer's write attempts regardless of what the UI shows.
 *
 * One deliberate simplification versus the investor portal: there is no separate Overview/Ledger
 * split here. DealerLedgerTab already carries both the summary cards and the full transaction
 * table, so splitting it into two tabs would only show the same numbers twice.
 */
export default function DealerPortalPage() {
  const { user } = useAuth();
  const dealerId = user?.dealerId ?? 0;

  if (!dealerId) {
    return <Alert type="error" showIcon message="This account is not linked to a dealer record." />;
  }

  return (
    <>
      <Typography.Title level={3}>My Investments</Typography.Title>

      <Card>
        <Tabs
          defaultActiveKey="overview"
          items={[
            { key: 'overview', label: 'Overview', children: <DealerMyDashboard dealerId={dealerId} /> },
            { key: 'profile', label: 'Profile', children: <DealerProfileTab dealerId={dealerId} /> },
            { key: 'investments', label: 'Investments', children: <DealerInvestmentsTab dealerId={dealerId} /> },
            { key: 'profit', label: 'Profit', children: <DealerProfitTab dealerId={dealerId} /> },
            { key: 'withdrawals', label: 'Withdrawals', children: <DealerWithdrawalsTab dealerId={dealerId} /> },
            { key: 'ledger', label: 'Ledger', children: <DealerLedgerTab dealerId={dealerId} /> },
          ]}
        />
      </Card>
    </>
  );
}
